module.exports = __webpack_public_path__ + "img/backyard-garden-and-planter.7f20223d.jpg";